
import {DEFAULT_PAGE_NUMBER,DEFAULT_PAGE_SIZE} from "./CorporateMasterTable/constants"

export const buildCorporateMasterFetchRequest = ({
    pageNumber = DEFAULT_PAGE_NUMBER,
    pageSize = DEFAULT_PAGE_SIZE,
    filter = {},
    sorted = {}
}) => {
    return {
        pageNumber,
        pageSize,
        filter: filter || {},
        sorted: sorted || {}
    };
};

export const buildCorporateMasterFilterPayload = ({
    selectedCorporates = [],
    salesAssociates,
    salesAssociatesEmail,
    teamLeader,
    region,
}) => {
    const payload = {
        salesAssociates: salesAssociates || null,
        salesAssociatesEmail: salesAssociatesEmail || null,
        teamLeader: teamLeader || null,
        region: region || null,
    };

    if (selectedCorporates.length > 0) {
        payload.corporateIds = selectedCorporates.map((c) => c.id);
        payload.corporateNames = selectedCorporates.map((c) => c.name);
    } else {
        payload.corporateIds = null;
        payload.corporateNames = null;
    }

    return payload;
};

export const getSelectedCorporatesFromFilter = (currentFilter = {}, corporates = []) => {
    const { corporateIds, corporateNames } = currentFilter;

    if (!corporateIds || !corporateNames || !corporateIds.length) {
        return [];
    }

    return corporateIds.map((id, index) => {
        const corporate = corporates.find((c) => c.id === id);
        return {
            id,
            name: corporateNames[index] || corporate?.name || String(id),
        };
    });
};